module.exports = __webpack_public_path__ + "img/kachel-einzelneprodukte_REISHIPLUS.4daf7b57.png";